/** IMPORTANT: routes added here must also be added to our waf-stack in cdk */
export const endpoints = {
  graphql: "/graphql",

  auth: {
    base: "/auth",
    refresh: "/auth/refresh",
    signOut: "/auth/sign-out",
  },
  eventFeed: {
    base: "/events",
    receiver: "/events/receiver",
  },

  assets: "/assets",

  health: "/health",
  live: "/live",

  download: {
    base: "/download",
    file: "/download/file",
  },

  companion: {
    base: "/companion",
    s3Params: "/companion/s3/params",
  },

  userActionLog: {
    base: "/ual",
    create: "/ual/collect",
  },

  labAppsBackend: {
    base: "/lab-apps-backend",
    getOne: "/lab-apps-backend/:labAppId",
  },

  webhooks: {
    base: "/webhooks",
    stems: "/webhooks/stems",
    trolley: "/webhooks/trolley",
  },
} as const;
